var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React from "react";
import classnames from "classnames";
import { withNativeProps } from "../../utils/mergeProps";
import Button from "../button";
export var ModalActionButton = function ModalActionButton(props) {
  var action = props.action,
    onAction = props.onAction;
  var key = action.key,
    text = action.text,
    btnType = action.btnType,
    className = action.className,
    _action$block = action.block,
    block = _action$block === void 0 ? true : _action$block,
    onClick = action.onClick,
    type = action.type,
    otherProps = __rest(action, ["key", "text", "btnType", "className", "block", "onClick", "type"]);
  var isPrimary = type === "primary";
  var BtnProps = Object.assign({
    block: block,
    type: type
  }, otherProps);
  return withNativeProps(action, /*#__PURE__*/React.createElement(Button, Object.assign({
    key: key,
    onClick: onAction,
    className: classnames("modal-button", className, {
      "modal-button-primary": isPrimary
    }),
    fill: isPrimary ? "solid" : undefined,
    size: 'middle',
    round: btnType === "round"
  }, BtnProps), text));
};